export default __webpack_public_path__ + "static/media/top_banner.25b26f6c.gif";